module.exports = __webpack_public_path__ + "img/KamaranSubhan-Goran.4f3d0a6d.jpg";